module.exports = __webpack_public_path__ + "static/media/WhiteDotted.b357991e.svg";